import { createFileRoute } from '@tanstack/react-router';

import { Box } from '@mantine/core';

import { useLegalEntityContext } from '@/context/LegalEntityContext';
import { RoomCalculationConfigPanel } from '@/features/legal-entities/components/RoomCalculationConfigPanel';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/company/room-calculation')({
  component: CompanyRoomCalculationPage,
  head: () => buildHead('roomCalculation'),
});

function CompanyRoomCalculationPage() {
  const { activeEntity } = useLegalEntityContext();

  if (!activeEntity) return null;

  return (
    <Box px='xl' py='lg'>
      <RoomCalculationConfigPanel entityId={activeEntity.id} />
    </Box>
  );
}
